module.exports = __webpack_public_path__ + "static/media/dog-pit-bull.b913de92.png";